<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--user">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserResult',
    props: { item: Object, focused: Boolean },
    emits: ['select']
}
</script>
